import { Component,  Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatSidenav } from 'src/app/core/core';
import { OktaAuthStateService } from '@okta/okta-angular';
import { combineLatest, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ICtaNavigationItem } from 'src/app/model/sitefinity/ICtaNavigationItem';
import { PGHOktaService } from 'src/app/core/core';
import { PGHIdentityService } from 'src/app/core/services/pghidentity.service';
import { PGHIdentityAuthStateService } from 'src/app/core/services/pghidentity-auth-state.service';

import { LoggedInNavlistComponent } from './logged-in-navlist/logged-in-navlist.component';
import { LoggedOutNavlistComponent } from './logged-out-navlist/logged-out-navlist.component';

export enum NavLists {
  none,
  root,
  profile,
  claims,
  coverage
}

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    imports: [LoggedInNavlistComponent, LoggedOutNavlistComponent]
})
export class SidenavComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isShowing: boolean;
  @Input() sidenavRef: MatSidenav;

  NavLists = NavLists;
  isAuthenticated: boolean = false;
  currentNavList: number = NavLists.root;
  userGivenName: string = '';
  headerChildItems: { [id: string]: ICtaNavigationItem };

  private destroy$ = new Subject<void>();

  constructor(
    private oktaAuth: OktaAuthStateService,
    private pghOktaService: PGHOktaService,
    private pghIdentityService: PGHIdentityService,
    private identityAuthStateService: PGHIdentityAuthStateService
  ) { }

  async ngOnInit(): Promise<void> {
    // Mirrors header.component.ts's dual-provider check - a user can be authenticated via
    // Okta OR the separate PGHIdentityService/EZ-Pass flow (its own token storage, unrelated
    // to Okta's). Checking Okta alone here caused the mobile sidenav to show the logged-out
    // nav for users who are genuinely logged in via the other provider, even though the
    // desktop header (which already checks both) showed the correct logged-in nav.
    this.isAuthenticated = this.pghOktaService.isTokenValid() || this.pghIdentityService.isTokenValid();
    if (this.isAuthenticated) {
      const user = (await this.pghOktaService.getUser()) || this.pghIdentityService.getUser();
      this.userGivenName = user?.given_name;
    }
    combineLatest([
      this.oktaAuth.authState$.pipe(map((authState) => authState?.isAuthenticated ?? false)),
      this.identityAuthStateService.authState$.pipe(map((authState) => authState.isAuthenticated)),
    ])
      .pipe(
        map(([okta, identity]) => okta || identity),
        takeUntil(this.destroy$)
      )
      .subscribe((isAuthenticated) => (this.isAuthenticated = isAuthenticated));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isShowing && changes.isShowing.currentValue === false) {
      this.currentNavList = NavLists.root;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
